export default __webpack_public_path__ + "static/media/twitch.1bceb263.svg";